import defineMessages from "../../../common/helpers/defineMessages";

const messages = defineMessages({
    title: {
        id: "article.experience.title",
    },
    description: {
        id: "article.experience.description",
    },
    featuresTitle: {
        id: "article.experience.features.title"
    },
    featuresDescription: {
        id: "article.experience.features.description"
    },
    features1Title: {
        id: "article.experience.features.1.title"
    },
    features1Description: {
        id: "article.experience.features.1.description"
    },
    features2Title: {
        id: "article.experience.features.2.title"
    },
    features2Description: {
        id: "article.experience.features.2.description"
    },
    features3Title: {
        id: "article.experience.features.3.title"
    },
    features3Description1: {
        id: "article.experience.features.3.description.1"
    },
    features3Description2: {
        id: "article.experience.features.3.description.2"
    },
    features3Description3: {
        id: "article.experience.features.3.description.3"
    },
    features4Title: {
        id: "article.experience.features.4.title"
    },
    features4Description: {
        id: "article.experience.features.4.description"
    },
    tipTitle: {
        id: "article.experience.tip.title"
    },
    tip1: {
        id: "article.experience.tip.1"
    },
    tip2: {
        id: "article.experience.tip.2"
    },
    tip3: {
        id: "article.experience.tip.3"
    },
    tip4: {
        id: "article.experience.tip.4"
    },
    themes: {
        id: "article.experience.themes",
    },
    basic: {
        id: "experienceEditor.theme.basic",
    },
    easter: {
        id: "easter.eggPainting",
    },
    christmasTuning: {
        id: "christmas.title",
    },
    newTheme: {
        id: "notification.new",
    }
});

export default messages;
